exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-form[data-v-59415ce8] {\n  margin-bottom: 20px;\n}\n.booking-return-table[data-v-59415ce8] {\n  padding: 20px;\n}\n.pagination-container[data-v-59415ce8] {\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
